import React from 'react';
import './PricingScreen.css';

const PricingScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="pricing-screen">
      <h1>Pricing</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default PricingScreen; 